var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-wrapper",attrs:{"id":"app"}},[_c('loading'),_c('router-view',{attrs:{"name":"header"}}),_c('main',[_c('section',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)]),_c('w-version')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }